import React from 'react';
import PropTypes from 'prop-types';
import strings from '../locales/';
import utilFunction from '../../containers/function';

const Table = props => (
  <div className="module-table table-acm-temp-fix-style top">
    <table>
      <thead>
        <tr>
          <th className="bd left">
            <a onClick={props.handleSort}>
              {props.language.account.workingShiftGroup.name} <i className="fas fa-arrows-alt-v" />
            </a>
          </th>
          <th className="th200 center ">
            {props.language.account.workingShiftGroup.workingShiftGroupType}
            <div>
              <i className="fas fa-question-circle" />
              <span>{props.language.account.workingShiftGroup.workingShiftGroupTypeHelp}</span>
            </div>
          </th>
          <th className="th200 center ">
            {props.language.account.workingShiftGroup.workingShiftStructureDays}
            <div>
              <i className="fas fa-question-circle" />
              <span>{props.language.account.workingShiftGroup.workingShiftStructureDaysHelp}</span>
            </div>
          </th>
          <th className="th150 center ">
            {props.language.account.workingShiftGroup.workingShiftStartDate}
            <div>
              <i className="fas fa-question-circle" />
              <span>{props.language.account.workingShiftGroup.workingShiftStartDateHelp}</span>
            </div>
          </th>
          {props.buttonShow && <th className="th100">{props.language.account.table.setting}</th>}
        </tr>
      </thead>
      <tbody>
        {props.datos.map((item, i) => (
          <tr key={`row-${i}`}>
            <td className={!item.state ? 'bd-gray' : 'bd-green'}>
              {item.alias}
            </td>
            <td className="center">
              {item.isDynamicShift ? 
                props.language.account.workingShiftGroup.dynamicWorkingShift
                : props.language.account.workingShiftGroup.fixedStructureWorkingShift}
            </td>
            <td className="center">
              {item.isDynamicShift ? 
                props.language.account.workingShiftGroup.doesNotApply
                : item.quantityDays}
            </td>
            <td className="center">
              {item.shiftStart ? 
                (utilFunction.getFormatFunction(
                  {type:"PARSE_DATE_STRING",format:["%d-%m-%Y","%Y-%m-%d"]}
                ))(item.shiftStart)
                : props.language.account.workingShiftGroup.doesNotApply}
            </td>
            {props.buttonShow && (
              <td>
                <div className="button-setting flex justify-center">
                  <div />
                  {item.state ? (
                    <div>
                      <a>
                        <span className="hover-title">
                          {props.language.account.workingShiftGroup.editText}
                        </span>{' '}
                        <i
                          data-datos={JSON.stringify(item)}
                          data-close="ok"
                          onClick={props.handleModal}
                          className="fas fa-edit"
                        />{' '}
                      </a>
                    </div>
                  ) : (null)}
                  {!item.hasUsers ? (
                    <div>
                      <a>
                        <span className="hover-title">
                          {' '}
                          {props.language.account.workingShiftGroup.deleteText}
                        </span>{' '}
                        <i
                          data-datos={JSON.stringify(item)}
                          data-close="ok"
                          onClick={props.handleModalDelete}
                          className="fas fa-times-circle"
                        />{' '}
                      </a>
                    </div>
                  ) : (
                    <div>
                      <a className="button-action-popup-help">
                        <div>
                          <p><strong className="red">{props.language.account.workingShiftGroup.cantDeleteHelp1}</strong></p>
                          <p>{props.language.account.workingShiftGroup.cantDeleteHelp2}</p>
                        </div>
                        <i
                          data-close="ok"
                          className="fas fa-times-circle disabled"
                        />{' '}
                      </a>
                    </div>
                    )}
                </div>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
    {props.loadingTable && (
      <div className="loading-table">
        <h6>
          <i className="fas fa-spinner fa-spin" />
        </h6>
      </div>
    )}
    {props.pag >= props.count.pages && (
      <div className="loading-table">
        <h6>{props.datos.length > 0 ? props.language.account.table.endTime : props.language.account.others.noData}</h6>
      </div>
    )}
  </div>
);

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/account_working_shift_group/table.jsx